import { BaseAPI } from 'API/BaseApi';
import { IVestingResponse } from 'types/order/vestings/IVestingResponse';

interface NormalizedVestingsData {
  vestings: IVestingResponse[];
  vestingsById: Record<string, IVestingResponse>;
}
export const VestingsAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listVestings: build.query<NormalizedVestingsData, void>({
      query: () => ({
        url: '/timber/api/internal/vestings',
        method: 'GET',
      }),
      transformResponse: (response: IVestingResponse[]) => {
        const vestingsById = {};
        response.forEach((vesting) => {
          vestingsById[vesting.id] = vesting;
        });
        return { vestings: response, vestingsById };
      },
    }),
  }),
});

export const { useListVestingsQuery } = VestingsAPI;

export const defaultNormalizedVestingsData: NormalizedVestingsData = {
  vestings: [],
  vestingsById: {},
};
